import React, { useState } from 'react';
import '../styles/Info.css';

function Info() {
    let [contact, setContact] = useState([false])

    function ShowContact() {
        var email = [...contact];
        email[0] = 'vanishedfantasy gmail com';
        setContact(email);
    }

    return (
        <div className='info'>
            <br />
            <p>
                <i>Sima Kim</i> explores the possibilities of philosophy possessed in technology through various media. In particular, he has been interested in the visible/invisible mixing and programming of material/non-material properties of data. From producing music of British R&B musician, RENÉ to participating in exhibitions such as Is it Noise?(Seoul Museum of Art, 2014) and The Scrap(2018, 2019), his practices range in various fields including music, art and design. Also, he is also interested in projects that interact and communicate with the public so he gave lectures on electronic music composition using algorithms at the workshop, Sample the city(Rewire Festival 2017, Netherlands) and held Electronic Music Workshop(2020) with the support of the Music Association of Korea. After completing graphic interaction design studies at Minerva Art Academy, Hanze University of Applied Sciences, Netherlands, he continues to broaden conceptual and technological horizons of his practice.
            </p>
            <br />

            <h3>Educations</h3>
            <ul>
                Graphic & Interaction Design, Bachelor, Minerva Art Academy, Hanze UAS, 2020<br />
                Sonology, Propeadeutic, Royal Conservatory in The Hague, 2016<br />
            </ul>
            <br />

            <h3>Exhibitions</h3>
            <ul>
                Party in a Box!, Art Center Nabi, Seoul, 11~12/2021 <br />
                The Scrap 2019, Samyook Building, Seoul, 12/2019 <br />
                The Scrap 2018, Cultural Station Seoul, Seoul, 06/2018 <br />
                Sonified Objects, Gemak, Hague, 07/2015 <br />
                Is It Noise?, Seoul Museum of Art, Seoul, 05~06/2014 <br />
            </ul>
            <br />

            <h3>Lectures</h3>
            <ul>
                Shape & Sound Of Poetry, 아는사람, Online, 2021 <br />
                Electronic Music Workshop, 지하소문, Seoul, 2020 <br />
                Sample the City Workshop, Rewire Festival, Hague, 2017 <br />
            </ul>
            <br />

            <h3>Performances</h3>
            <ul>
                Meowww Showcase Vol.1, Senggi Studio, Seoul, 07/2021 <br />
                Wonderwerp #70, Studio Loos, Hague, 03/2016 <br />
                Paris Music Week, Paris, 06/2015 <br />
                Rewire Festival 2015, Hague, 05/2015 <br />
                ADE x Shourai Session, Amsterdam, 10/2014 <br />
                I × M by IdleMoments Vol.6, Osaka, 04/2014 <br />
                Shigeto South Korea Tour, Busan, 11/2013 <br />
            </ul>
            <br />

            <h4 style={{fontSize: "20px"}} onClick={() => window.open('https://www.instagram.com/catpsalm', '_blank')}>Instagram</h4>
            <h4 style={{fontSize: "20px"}} onClick={ShowContact}> Contact ← Click This </h4> {contact}
            
            <p></p>
            <br />

        </div>
    )
}

export default Info;